function findElement(_element) {
  var _ref = _element || {},
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    element = _ref.element;
  if (element) return element;
  if (id) return document.getElementById(id);
  var elements = document.getElementsByClassName(className);
  if (elements) return elements[0];
  return null;
}

export { findElement as default };
//# sourceMappingURL=find-element.esm.js.map
